import { useController, useFormContext, useWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { CountrySelectorFormSchema } from "@/models/patient"
import { PostalCodeSelector as PostalCodeSelectorCommon } from "@/modules/inbound-wizard/components/contact/address/postal-code-selector"

const PostalCodeSelector = (props: React.HTMLAttributes<HTMLParagraphElement> & { label?: string }) => {
  const { t } = useTranslation()
  const form = useFormContext<CountrySelectorFormSchema>()
  const {
    setValue,
    control,
    trigger,
    formState: { errors: formErrors },
  } = form

  const countryField = useWatch({ control, name: "country" })
  const { field: postalCode } = useController({ name: "postalCode", control })

  return (
    <PostalCodeSelectorCommon
      {...props}
      className="col-span-2"
      countryIsoCode={countryField}
      value={postalCode.value}
      onSelect={(data) => {
        if (data) {
          setValue("city", data.city ?? "", { shouldValidate: true, shouldDirty: true })
        }
      }}
      error={t(formErrors?.postalCode?.message || "")}
      onChange={(value) => {
        postalCode.onChange(value)
        trigger("postalCode")
      }}
    />
  )
}

export { PostalCodeSelector }
